import { GetUserInfoApi } from "@/request/api"
export default {
    namespaced: true,
    state: {
        userInfo: {
            user: null,
            term: null,
            fen: null,
            is_admin: false,
        }
    },
    mutations: {
        changeUserInfo(state, payload) {
            state.userInfo = payload;
        },
        changeUserFen(state, payload) {
            state.userInfo.fen = payload;
        },
        changeUserIsAdmin(state, payload) {
            state.userInfo.is_admin = payload;
        },
        changeUserTerm(state, payload) {
            state.userInfo.term = payload;
        },
        changeMyName(state, payload) {
            state.userInfo.user = payload;
        },

    },
    // 发请求
    actions: {
        async asyncChangeUserInfo({ commit }, payload) {
            let GetUserInfoApiRes = await GetUserInfoApi();
            console.log(GetUserInfoApiRes);
            if (!GetUserInfoApiRes) return;
            commit("changeUserInfo", {
                user: GetUserInfoApiRes.name,
                term: GetUserInfoApiRes.term,
                fen: GetUserInfoApiRes.fen,
                is_admin: GetUserInfoApiRes.is_admin,
            })
        }
    }

}